import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row } from "react-bootstrap";

import "./SchedulingPage.scss";
import messages from '../../assets/i18n'
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import Scheduling from "../../containers/Scheduling/Scheduling";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { HeaderActions, FooterActions } from "../../components";

function SchedulingPage (props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
	const loadId = useSelector(state => state.load.loadId);
	const freeGates = useSelector(state => state.freeGates.freeGates);
	const loading = useSelector(state => state.freeGates.loading);
	const scheduling = useSelector(state => state.scheduling);

	const getFreeGates = (loadId) =>
		dispatch({
			type: "GET_FREE_GATES",
			payload: loadId,
		});
	const cleanGates = () =>
		dispatch({
			type: 'CLEAN_GATES'
		});
	const actionSaveScheduling = (idCarga, idPortao, date, hour) =>
		dispatch({
			type: "SAVE_SCHEDULING",
			payload: {
				idCarga: idCarga,
				idPortao: idPortao,
				dtEntrega: date,
				horaEntrega: hour,
			}
		});

	useEffect(() => {
		if (loadId && !freeGates) {
			getFreeGates(loadId);
		}
	// eslint-disable-next-line
	}, [loadId, freeGates])

	const saveScheduling = () => {
		const { idLoad, gate, date, hour  } = scheduling;
		actionSaveScheduling(idLoad, gate, date, hour);
		props.history.push(`/load-details`);
	};

	const pageBack = () => {
		cleanGates();
		props.history.push(`/load-details`);
	};

	const titlePage = (
		freeGates ? 
		<span className="">{messages[lang].load} {freeGates.idCarga}
			<span className="ml-5 font-weight-normal">
				{freeGates.semanaComercial}
			</span>
			<span className="mx-2 font-weight-normal"> | </span>
			<span className="font-weight-normal">
				{freeGates.nomeCd}
			</span>
		</span>
		: 
		<span>{messages[lang].scheduling + ' ' + messages[lang].loading}</span>
	)

	const ButtonSave = () => <ButtonStandard
		id="scheduling-save-button"
		disabled={
			scheduling.date !== "" &&
				scheduling.hour !== "" &&
				scheduling.gate !== ""
				? false
				: true
		}
		text={messages[lang].save}
		textClass="text-3"
		className="btn btn-primary btn-save btn-light"
		onClick={saveScheduling}
	/>

	return (
		<div className="page-scheduling">
			<HeaderActions pageBack={pageBack} titlePage={titlePage} />
				{
					Object.keys(freeGates).length <= 0 ?
						<Container>
							<Row className="justify-content-center mt-5">
								<LoadingSpinner />
							</Row>
						</Container>
					:
						<>
							<Scheduling freeGates={freeGates} loading={loading} />
						</>
				}	
			<FooterActions ButtonGroupRight={ButtonSave} />
		</div>
	);
}

export default withRouter(SchedulingPage);
